import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import DesignA from "@/components/DesignA";
import Disclaimer from "@/components/Disclaimer";
import { toast } from "sonner";

export default function Landing() {
  const [searchParams] = useSearchParams();
  const [donors, setDonors] = useState([]);
  const [doubleIt, setDoubleIt] = useState(false);
  const [supporterName, setSupporterName] = useState("");
  const [supporterEmail, setSupporterEmail] = useState("");
  const [consentToDisplay, setConsentToDisplay] = useState(false);
  const [customAmount, setCustomAmount] = useState(500);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.documentElement.classList.remove("design-b");
    document.documentElement.classList.add("design-a");
  }, []);

  useEffect(() => {
    api.get("/ticker").then((r) => setDonors(r.data.donors || [])).catch(() => {});
  }, []);

  // ?upsell=mega — surface a satirical toast and pre-fill the slider to $400
  useEffect(() => {
    if (searchParams.get("upsell") === "mega") {
      setCustomAmount(400);
      toast.message("⚡ MEGA upsell unlocked", {
        description: "Slide to $400 below — or pick any amount. Eagles approve either way.",
        duration: 6000,
      });
    }
  }, [searchParams]);

  const startCheckout = async (overridePackageId = null, overrideCustomAmount = null) => {
    setLoading(true);
    try {
      const package_id = overridePackageId || (doubleIt ? "double" : "standard");
      const body = {
        package_id,
        origin_url: window.location.origin,
        design: "A",
        supporter_name: supporterName || "Anonymous Patriot",
        consent_to_display: consentToDisplay,
      };
      if (package_id === "custom") {
        body.custom_amount = overrideCustomAmount != null ? overrideCustomAmount : customAmount;
      }
      if (supporterEmail && supporterEmail.includes("@")) {
        body.supporter_email = supporterEmail;
      }
      const { data } = await api.post("/checkout/session", body);
      if (data?.url) {
        window.location.href = data.url;
      }
    } catch (e) {
      console.error(e);
      const detail = e?.response?.data?.detail || "Checkout failed. Please try again.";
      toast.error(detail);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="design-a min-h-screen">
      <DesignA
        donors={donors}
        doubleIt={doubleIt}
        setDoubleIt={setDoubleIt}
        supporterName={supporterName}
        setSupporterName={setSupporterName}
        supporterEmail={supporterEmail}
        setSupporterEmail={setSupporterEmail}
        consentToDisplay={consentToDisplay}
        setConsentToDisplay={setConsentToDisplay}
        customAmount={customAmount}
        setCustomAmount={setCustomAmount}
        startCheckout={startCheckout}
        loading={loading}
      />
      <Disclaimer />
    </div>
  );
}
